<template>
  <BlockWrapper class="we-did" small>
    <bim-text type=h5 bold class="text-center we-did__title">Что мы делаем</bim-text>
    <bim-row class="work__wrapper">
      <bim-col
        cols=12
        md=6
        v-for="work of works"
        :key="work.title"
        class="work"
      >
        <bim-text type=accent bold>{{ work.title }}</bim-text>
        <img alt :src="work.img" :style="{ margin: work.imgPadding }" />
        <bim-text type=main class="work__desc mb-9">{{ work.desc }}</bim-text>
        <a :href="work.link" target="_blank" class="work__link d-block">
          <bim-text type=main><span class="work__link--border">Узнать подробнее</span></bim-text>
        </a>
      </bim-col>
    </bim-row>
  </BlockWrapper>
</template>

<script>
import bimRow from '@bimlib/components/bimRow'
import bimCol from '@bimlib/components/bimCol'
import bimContainer from '@bimlib/components/bimContainer'

export default {
  name: "block",
  components: {
    bimCol,
    bimRow,
    bimContainer,
  },
  inject: ['getImgPath'],
  computed: {
    works() {
      return [
        {
          title: "Разрабатываем BIM",
          img: this.getImgPath('img-special-landing-cash-12.svg'),
          imgPadding: '44px 0 42px 0',
          desc: "Инженеры с удовольствием используют созданные BIMLIB модели в своих проектах. Мы внимательны к деталям и потребностям.",
          link: "/bim/",
        },
        {
          title: "Помогаем продавать больше",
          img: this.getImgPath('img-special-landing-cash-13.svg'),
          imgPadding: '9px 0 35px 0',
          desc: "Продвижение цифровых двойников для производителей стройматериалов и оборудования.",
          link: "/promotion/",
        },
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./src/front_white/sass/components/settings";
.we-did {
  padding: 80px 0 73px;

  .we-did__title {
    margin-bottom: 52px;
  }
}
.work {
  &:first-child {
    @media screen and (max-width: $breakpoint-md) {
      margin-bottom: 32px;
    }
  }
  .work__link,
  .work__desc {
    line-height: 1.5;
    letter-spacing: 0.2px;
  }
  .work__link--border {
    padding-bottom: 3px;
    border-bottom: 2px solid $primary-color;
  }
}
</style>
